import { observer } from 'mobx-react'
import { useCallback, useEffect } from 'react'
import { Modal } from 'antd'
import classNames from 'classnames'
import { IconImage } from '../Icon'
import GoodsDetail from './GoodsDetail'
import GoodsPreview from './GoodsPreview'
import styles from './GoodsDetailModal.module.less'
import goodsDetailState from './GoodsDetailState'
import emitter, { EmitterEvents } from '@/helpers/emitter'

export interface GoodsDetailModalProps {
  visible: boolean
  materialId: number
  onClose: () => void
}

const GoodsDetailModal = observer(({ visible, onClose, materialId }: GoodsDetailModalProps) => {
  useEffect(() => {
    goodsDetailState.setMaterialId(materialId)
  }, [materialId])

  const getInfo = useCallback(() => goodsDetailState.getInfo(), [])

  useEffect(() => {
    emitter.on(EmitterEvents.PAY_SUCCESS, getInfo)
    return () => {
      emitter.off(EmitterEvents.PAY_SUCCESS, getInfo)
    }
  }, [getInfo])

  return (
    <Modal
      open={visible}
      footer={null}
      closeIcon={false}
      onCancel={onClose}
      width={1048}
      centered
      title={null}
      styles={{
        body: {
          padding: 0,
        },
        content: {
          padding: 0,
          overflow: 'hidden',
          borderRadius: 8,
        },
      }}
    >
      <div className={styles.goodsDetailModal}>
        <div className={styles.modalClose} onClick={onClose}>
          <IconImage width={16} src='IconClose' />
        </div>

        <div className={styles.tabs}>
          {goodsDetailState.tabs.map((item) => (
            <span
              key={item.key}
              onClick={() => goodsDetailState.setActiveTab(item.key)}
              className={classNames(styles.tabItem, {
                [styles.active]: goodsDetailState.activeTab === item.key,
              })}
            >
              {item.label}
            </span>
          ))}
        </div>
        {goodsDetailState.activeTab === 'detail' && <GoodsDetail state={goodsDetailState!} />}
        {goodsDetailState.activeTab === 'preview' && <GoodsPreview state={goodsDetailState!} />}
      </div>
    </Modal>
  )
})

export default GoodsDetailModal
